import { useIntl } from 'react-intl';
import { FeatureIcon } from '@rossum/ui';
import { TablerIcon } from '@rossum/ui/icons/tabler';
import { Stack, Typography } from '@rossum/ui/material';
import { LocalizationKeys } from '../../../i18n';
import { linebreak } from '../../../lib/formaterValues';

type Props = {
  icon: TablerIcon;
  title: LocalizationKeys;
  text?: LocalizationKeys;
  inGraph?: boolean;
  inTable?: boolean;
};

const InfoPlaceholder = ({ title, text, icon, inGraph, inTable }: Props) => {
  const intl = useIntl();

  return (
    <Stack
      spacing={1}
      sx={{
        padding: '200px 0',
        alignItems: 'center',
        ...(inGraph && { padding: '0px 0px 80px 0px' }),
        ...(inTable && { padding: '80px 0px', margin: '0 auto' }),
      }}
    >
      <FeatureIcon content={icon} color="secondary" />
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {intl.formatMessage({ id: title })}
      </Typography>
      {text && (
        <Typography variant="body2">
          {intl.formatMessage({ id: text }, { linebreak })}
        </Typography>
      )}
    </Stack>
  );
};

export default InfoPlaceholder;
